import { render, staticRenderFns } from "./BusinessAddress.vue?vue&type=template&id=13c9108a&scoped=true&"
import script from "./BusinessAddress.vue?vue&type=script&lang=js&"
export * from "./BusinessAddress.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAddress.vue?vue&type=style&index=0&id=13c9108a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9108a",
  null
  
)

export default component.exports